import Vue from 'vue'
import VueFlashMessage from '@smartweb/vue-flash-message'

Vue.use(VueFlashMessage)
